import { workedKPI, egDeviceKPILiveMessage, unsubscribeFarmAnalyseKPI } from '../actions/farm-monitor';
import { isToday, isElasticLoad } from '../helpers/common';
import * as actionTypes from '../constants/action-types';
import {
    PLAN_TYPE_LIST, GROUP_FARM_MONITOR_ANALYZE_KPI, GROUP_FARM_MONITOR_DEVICE_KPI
    , TOPIC_LATEST_KPI_PLAN, TOPIC_KPI_PLAN, TOPIC_LOAD_PLAN, TOPIC_QLOST, TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR,
} from '../constants';
import { subscribe, unsubscribe } from '../actions/socket';
import moment from 'moment';
import { secondsToTime } from '../helpers/moment-ex';
// import { DEFAULT_QLOST_SPAN_SEC } from '../components/map/marker/MapMarker';

const subscribeFarmKPI = (store, action) => {
    if (!window.socketClient) return;
    const { range, farmId } = action.params;
    const actionList = window.socketClient.getActionList();

    if (isToday(range)) {
        const isSubscribed = deviceId => {
            if (actionList.hasOwnProperty(GROUP_FARM_MONITOR_ANALYZE_KPI)) {
                const findActions = actionList[GROUP_FARM_MONITOR_ANALYZE_KPI].filter(e => e.deviceId === deviceId);
                return (findActions.length > 0);
            }
            return false;
        };

        const topics = getFarmAnalyzeTopics({ farmId: farmId });

        const notifications = [];
        for (const item of topics) {
            if (item.subscribeDeviceId && isSubscribed(item.subscribeDeviceId)) continue;
            notifications.push({ deviceId: item.subscribeDeviceId, name: item.topic, ...item.action && { action: item.action } });
        }

        if (notifications.length > 0) {
            store.dispatch(subscribe(notifications, GROUP_FARM_MONITOR_ANALYZE_KPI));
        }
    } else if (actionList.hasOwnProperty(GROUP_FARM_MONITOR_ANALYZE_KPI)) {
        store.dispatch(unsubscribeFarmAnalyseKPI(true));
    }
    return;
}

const unsubscribeFarmKPI = (store, action) => {
    return store.dispatch(unsubscribe(GROUP_FARM_MONITOR_ANALYZE_KPI, action.clearMessages));
}

const subscribeEgDeviceKPI = (store, action) => {
    if (!window.socketClient) return;
    const range = store.getState().analyze.searchParams.range;
    const { payload } = action;
    const actionList = window.socketClient.getActionList();

    if (isToday(range)) {
        const notifications = [];
        payload && payload.forEach(item => {
            const isSubscribed = deviceId => {
                if (actionList.hasOwnProperty(`${GROUP_FARM_MONITOR_DEVICE_KPI}`)) {
                    const findActions = actionList[`${GROUP_FARM_MONITOR_DEVICE_KPI}`].filter(e => e.deviceId === deviceId);
                    return (findActions.length > 0);
                }
                return false;
            };

            if (item.deviceId && isSubscribed(item.deviceId)) return;
            // notifications.push({ deviceId: item.deviceId, action: TOPIC_LATEST_EG_SENSOR, parameters: { sensor: "q_connection,battery_level,pto,fuel_level", equipment_group_uuid: item.egId } });
            notifications.push({ deviceId: item.deviceId, name: TOPIC_SENSOR, parameters: { sensor_type: "q_connection,battery_level,pto,fuel_level" } });
            // notifications.push({ deviceId: item.deviceId, name: TOPIC_QLOST });
        })

        store.dispatch(subscribe(notifications, `${GROUP_FARM_MONITOR_DEVICE_KPI}`));
    }
    else store.dispatch(unsubscribe(`${GROUP_FARM_MONITOR_DEVICE_KPI}`));
    return;
}

const unsubscribeEgDeviceKPI = (store) => {
    store.dispatch(unsubscribe(`${GROUP_FARM_MONITOR_DEVICE_KPI}`));
    return;
}

const pipeLiveData = (store, action) => {
    if (!action.message) return;
    const live = action.message;
    const state = store.getState();
    const { range } = state.analyze.searchParams;

    if ([TOPIC_LATEST_KPI_PLAN, TOPIC_KPI_PLAN, TOPIC_LOAD_PLAN].indexOf(live.name) >= 0 && isToday(range))
        return mergeFarmAnalyseKpiFromLive(store, live);
    else if ([TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR].indexOf(live.name) >= 0 && isToday(range)) {
        return mergeQPresentFromLive(store, live);
        // mergeQConnectionFromLive(store, live);
    } else if ([TOPIC_QLOST].indexOf(live.name) >= 0 && isToday(range)) {
        return;
        // return mergeQLostFromLive(store, live);
    }
}

const mergeFarmAnalyseKpiFromLive = (store, live) => {
    const state = store.getState();
    const farmId = state.farmMonitor.farmId;
    const topics = getFarmAnalyzeTopics({ farmId: farmId });

    const findTopics = topics.filter(e => e.subscribeDeviceId === live.deviceId &&
        (e.topic === live.name || e.action === live.name));
    if (findTopics.length === 0) return;

    const topic = findTopics[0];

    const data = live.initial ? live.message.data : live.message;
    const elastic = { isLive: true, data };

    PLAN_TYPE_LIST.forEach(item => store.dispatch(workedKPI(item.plan_type_id, topic.keyname, elastic)));
    return;
}

const mergeQPresentFromLive = (store, live) => {
    if (!live.message) return;

    const { connectionUpTime, ptoRPMSpeed, ptoRPMState, fuelLevel, batteryPercent } = getCanFromLive(live.message);

    let sensorData = { connected: true };
    if (connectionUpTime !== null) sensorData = { ...sensorData, connectionUpTime };
    if (ptoRPMState !== null) sensorData = { ...sensorData, ptoRPMState };
    if (ptoRPMSpeed !== null) sensorData = { ...sensorData, ptoRPMSpeed };
    if (ptoRPMState !== null) sensorData = { ...sensorData, ptoRPMState };
    if (fuelLevel !== null) sensorData = { ...sensorData, fuelLevel };
    if (batteryPercent !== null) sensorData = { ...sensorData, batteryPercent };

    return store.dispatch(egDeviceKPILiveMessage(live.deviceId, sensorData));
}

// const mergeQConnectionFromLive = (store, live) => {
//     const { deviceId, message } = live;
//     if (!message || !deviceId) return;
//     if (!message.hasOwnProperty('q_connection')) return;

//     const qConnection = message.q_connection.data;

//     let connected = null;

//     if (qConnection.hasOwnProperty("connected"))
//         connected = qConnection.connected;
//     else if (qConnection.hasOwnProperty("keep_alive_interval"))
//         connected = (parseInt(qConnection["keep_alive_interval"]) !== DEFAULT_QLOST_SPAN_SEC);
//     else if (qConnection.hasOwnProperty("keep-alive-interval"))
//         connected = (parseInt(qConnection["keep-alive-interval"]) !== DEFAULT_QLOST_SPAN_SEC);

//     if (connected !== null) return store.dispatch(egDeviceKPILiveMessage(deviceId, { connected }));

//     return;
// }

// const mergeQLostFromLive = (store, live) => {
//     const { deviceId, message } = live;
//     if (!message || !deviceId) return;

//     let connected = null;

//     if (message.hasOwnProperty("connected"))
//         connected = message.connected;
//     else if (message.hasOwnProperty("keep_alive_interval"))
//         connected = (parseInt(message["keep_alive_interval"]) !== DEFAULT_QLOST_SPAN_SEC);
//     else if (message.hasOwnProperty("keep-alive-interval"))
//         connected = (parseInt(message["keep-alive-interval"]) !== DEFAULT_QLOST_SPAN_SEC);

//     if (connected !== null) return store.dispatch(egDeviceKPILiveMessage(deviceId, { connected }));

//     return;
// }

const getCanFromLive = message => {
    const can = {
        connectionUpTime: null,
        ptoRPMState: null,
        ptoRPMSpeed: null,
        fuelLevel: null,
        batteryPercent: null
    };

    const getSensor = sensor => {
        if (!message.hasOwnProperty(sensor)) return;
        return message[sensor].data;
    };

    const getSensorData = (sensor, keyName) => {
        const sensorData = getSensor(sensor);
        if (!sensorData) return null;
        return typeof sensorData === "object" && sensorData.hasOwnProperty(keyName)
            && Number(sensorData[keyName]) ? sensorData[keyName] : null;
    };
    can.connectionUpTime = getSensorData("q_connection", "ts");
    can.ptoRPMSpeed = getSensorData("pto", "speed");
    can.ptoRPMState = getSensorData("pto", "state");
    can.fuelLevel = getSensorData("fuel_level", "percent");
    can.batteryPercent = getSensorData("battery_level", "percent");
    if (can.connectionUpTime !== null) {
        const utcTS = moment.utc().valueOf();
        can.connectionUpTime = secondsToTime((utcTS - message['q_connection'].ts) / 1000, false, true);
    }

    return can;
}

const getFarmAnalyzeTopics = params => {
    const topics = [], isAutomatic = isElasticLoad();
    topics.push({ deviceId: params.farmId, subscribeDeviceId: params.farmId, action: TOPIC_LATEST_KPI_PLAN, keyname: "work", parameters: { include_work: true } });
    topics.push({ deviceId: params.farmId, subscribeDeviceId: params.farmId, topic: TOPIC_KPI_PLAN, keyname: "work" });
    if (isAutomatic) topics.push({ deviceId: params.farmId, subscribeDeviceId: params.farmId, topic: TOPIC_LOAD_PLAN, keyname: "load" });
    return topics;
}

const farmMonitorMiddleware = store => {
    return next => action => {
        switch (action.type) {
            case actionTypes.FARM_MONITOR_GET_SUMMARY:
                action = { ...action, rangeId: store.getState().analyze.searchParams.rangeId };
                break;
            case actionTypes.FARM_MONITOR_GET_GRAPH:
                action = {
                    ...action,
                    range: store.getState().analyze.searchParams.range,
                    timezone: store.getState().farm.currentFarm.timezone_identifier
                };
                break;
            case actionTypes.FARM_MONITOR_GET_WORKED_KPI:
                action = {
                    ...action,
                    range: store.getState().analyze.searchParams.range,
                    timezone: store.getState().farm.currentFarm.timezone_identifier
                };
                break;
            case actionTypes.FARM_MONITOR_GET_WORKED_ACRES:
                action = { ...action, range: store.getState().analyze.searchParams.range };
                break;
            case actionTypes.FARM_MONITOR_GET_EG_WORED_ACRES:
                action = { ...action, range: store.getState().analyze.searchParams.range };
                break;
            case actionTypes.FARM_MONITOR_SUBSCRIBE_FARM_ANALYSE_KPI:
                subscribeFarmKPI(store, action);
                break;
            case actionTypes.FARM_MONITOR_UNSUBSCRIBE_FARM_ANALYSE_KPI:
                unsubscribeFarmKPI(store, action);
                break;
            case actionTypes.FARM_MONITOR_SUBSCRIBE_EG_DEVICE_KPI:
                subscribeEgDeviceKPI(store, action);
                break;
            case actionTypes.FARM_MONITOR_UNSUBSCRIBE_EG_DEVICE_KPI:
                unsubscribeEgDeviceKPI(store, action);
                break;
            case actionTypes.LIVE_MESSAGE:
                pipeLiveData(store, action);
                break;
            default:
                break;
        }

        return next(action);
    };
};

export default farmMonitorMiddleware;